import Vue from 'vue'
import Vuex from 'vuex'
import Api from "@/services/Server"
import qs from 'querystring'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    presenceQR({ }, kodeqr) {
      let nim = localStorage.getItem("npm");
      let data = qs.stringify({ nim, kodeqr });

      Api.presenceQR(data).then(res => {
        console.log(res.data.message)
        if (res.data.message == "Presensi berhasil!") {
          Vue.swal.fire(
            {
              icon: 'success',
              title: 'Presensi berhasil',
            }
          )
        } else if (res.data.message == "Anda Sudah Presensi!") {
          Vue.swal.fire(
            {
              icon: 'warning',
              title: 'Anda sudah presensi',
            }
          )
        } else if (res.data.message == "Presensi tidak berhasil!") {
          Vue.swal.fire(
            {
              icon: 'error',
              title: 'Presensi tidak berhasil',
            }
          )
        }
      })
    }
  },
  modules: {
  }
})
